<companyid-content-wrapper classNames="flex-col w-full pt-[100px] z-10 px-5" assetPath="about-us/about-us-header">
    <div class="flex flex-col tab:items-center w-full">
        <companyid-crm-solutions-title class="tab:text-center mob:text-center" />
        <companyid-contact-and-plans-buttons class="mob:mt-40px" />
    </div>
    <div class="flex justify-between gap-x-30px w-full mob:flex-col mt-[100px] mob:gap-60px">
        <div class="flex flex-col text-white text-h4-bold gap-5px border-t border-stroke w-full pt-15px">
            <span i18n=":@@about-us-our-mission">Our Mission</span>
            <span class="text-stroke text-medium-regular" i18n=":@@about-us-transforming"
                >Transforming CRM development: elevating efficiency and enjoyment with our expert solutions.</span
            >
        </div>
        <div
            class="flex flex-col border-t-6px border-secondary-color p-25px gap-25px w-full bg-white/[0.1] backdrop-blur-[42px]"
        >
            <span class="text-h5-semi-bold text-white" i18n=":@@about-us-empowering">Empowering CRM: </span>
            <span class="text-stroke text-large-regular" i18n=":@@about-us-streamlining">
                Streamlining workflow efficiency and code exploration. Our solutions enhance quality assurance across
                development phases, minimizing maintenance time.
            </span>
            <a
                i18n="@@button-explore-our-pricing-list"
                routerLink="/pricing"
                class="button-ghost-gray-with-arrow-top !text-white hover:!text-primary-text-color"
            >
                Explore our pricing list
                <companyid-arrow position="top-right" color="white" />
            </a>
        </div>
    </div>
</companyid-content-wrapper>
